import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { initLenis, scrollToId } from "@/lib/smoothScroll";
import { Navbar } from "@/components/margtor/Navbar";
import { Hero } from "@/components/margtor/Hero";
import { Marquee } from "@/components/margtor/Marquee";
import { Manifesto } from "@/components/margtor/Manifesto";
import { FieldStrip } from "@/components/margtor/FieldStrip";
import { Products } from "@/components/margtor/Products";
import { ModelsLine } from "@/components/margtor/ModelsLine";
import { PilotBand } from "@/components/margtor/PilotBand";
import { Markets } from "@/components/margtor/Markets";
import { MicroGrid } from "@/components/margtor/MicroGrid";
import { Financing } from "@/components/margtor/Financing";
import { FleetEconomics } from "@/components/margtor/FleetEconomics";
import { CapitalGroup } from "@/components/margtor/CapitalGroup";
import { Founders } from "@/components/margtor/Founders";
import { GWRStrip } from "@/components/margtor/GWRStrip";
import { ContactSection } from "@/components/margtor/ContactSection";
import { Footer } from "@/components/margtor/Footer";
import { PartnersPage } from "@/components/margtor/PartnersPage";
import PressPage from "@/components/margtor/PressPage";
import { KnowledgePage } from "@/components/margtor/KnowledgePage";
import { ArticlePage } from "@/components/margtor/ArticlePage";
import { PressStrip } from "@/components/margtor/PressStrip";
import { GroupSection } from "@/components/margtor/GroupSection";
import { ChinaPartner } from "@/components/margtor/ChinaPartner";
import { AmperiProof } from "@/components/margtor/AmperiProof";
import { Seo } from "@/components/margtor/Seo";
import { AskMargtor } from "@/components/margtor/AskMargtor";

const Landing = () => {
  useEffect(() => {
    initLenis();
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => scrollToId(id), 600);
    }
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <Products />
      <ModelsLine />
      <PilotBand />
      <Manifesto />
      <FieldStrip />
      <Markets />
      <MicroGrid />
      <Financing />
      <FleetEconomics />
      <CapitalGroup />
      <GroupSection />
      <PressStrip />
      <Founders />
      <GWRStrip />
      <AmperiProof />
      <ChinaPartner />
      <ContactSection />
    </main>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App" data-testid="margtor-landing">
          <Seo />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/knowledge" element={<KnowledgePage />} />
            <Route path="/knowledge/notes/:slug" element={<ArticlePage kind="note" />} />
            <Route path="/knowledge/:slug" element={<ArticlePage />} />
          </Routes>
          <Footer />
          <AskMargtor />
          <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0 } }} />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
